export type NamedGraph = {
  iri: string;
  isAlias: boolean;
  isVirtual: boolean;
};

export type Database = {
  id: string;
  refreshed: boolean;
  isOnline?: boolean;
  isVoiceboxEnabled?: boolean;
  models?: string[];
  namedGraphs?: Record<string, NamedGraph>;
  namedGraphsByModel?: Record<string, string[]>;
  namespaces?: Record<string, string>;
  sensitiveProperties?: string[];
  sensitivePropertyGroups?: Record<string, string[]>;
  voiceboxExampleQuestions?: string[];
};

export class DatabasesState {
  constructor(
    public databaseIds: string[] = [],
    public databasesById: Record<string, Database> = {},
    public pendingAddModelToDatabase: boolean = false,
    public pendingRefreshDatabases: boolean = false
  ) {}
}
